import cx from 'classnames'
import type { ComponentChild } from 'preact'
import './ValueLoading.css'

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const ValueLoading = <V extends unknown>({
	value,
	height,
	width,
	light,
	class: c,
	children,
}: {
	value?: V | undefined
	height?: number | string
	width?: number | string
	light?: true
	class?: string
	children?: ComponentChild | ((value: V) => ComponentChild)
}) => {
	if (value === undefined)
		return (
			<LoadingIndicator width={width} height={height} light={light} class={c} />
		)
	if (children === undefined) return <>{value}</>
	return typeof children === 'function' ? children(value) : children
}

export const LoadingIndicator = ({
	height,
	width,
	light,
	class: c,
}: {
	height?: number | string
	width?: number | string
	light?: true
	class?: string
}) => {
	if (height !== undefined && typeof height === 'number' && width === undefined)
		width = height * 5
	if (width !== undefined && typeof width === 'number' && height === undefined)
		height = width / 5
	if (height === undefined && width === undefined) {
		height = 24
		width = 120
	}
	return (
		<span
			class={cx(c, {
				'value-loading-light': light,
				'value-loading': !light,
			})}
			style={{
				height,
				width,
				display: 'inline-block',
				maxWidth: '100%',
			}}
		>
			<span class={'progress-animation'}></span>
		</span>
	)
}
